const {h, render, Component} = require('preact');
const PurchaseDate = require('./purchase_date')
const Status = require('./status')
const ExpiryDate = require('./expiry_date')
const CardLinked = require('./card_linked')
const ClaimPayment = require('./claim_payment')

class ClaimTable extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let details = this.props.claimDetails
    return (
      <table class="first-table">
        <PurchaseDate claimDetails={details}/>
        <Status claimDetails={details}/>
        <ExpiryDate claimDetails={details}/>
        <CardLinked claimDetails={details}/>
        <ClaimPayment claimDetails={details}/>
      </table>
    );
  }
}

module.exports = ClaimTable
